module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-creative-05@2x.980332d5.jpg";